require('./bootstrap');
import { Helper } from './helpers';
import Alpine from 'alpinejs';

// Livewire 3 fournit déjà Alpine (avec cloneNode, etc.). Ne pas l'écraser sur les pages Livewire.
if (!window.Alpine) {
    window.Alpine = Alpine;
    Alpine.start();
}

if (!window.Helper) {
    window.Helper = new Helper();
}